import React from 'react';

import type { ColumnMeta, TableVerticalAlign } from '../types';
import { getStickyStyle, tableCellVariants } from './tableStyles';

type TableCellProps<T> = {
  row: T;
  rowIndex: number;
  column: ColumnMeta<T>;
  clampCells?: boolean;
  cellsContentClassName?: string;
  verticalAlign: TableVerticalAlign;
  isLastRow?: boolean;
  cellProps?: React.TdHTMLAttributes<HTMLTableCellElement>;
};

const TableCell = <T,>({
  row,
  rowIndex,
  column,
  clampCells,
  cellsContentClassName,
  verticalAlign,
  isLastRow,
  cellProps,
}: TableCellProps<T>) => {
  const {
    className: externalClassName,
    style: externalStyle,
    ...restProps
  } = cellProps ?? {};
  const styles = tableCellVariants({
    align: column.align ?? 'left',
    verticalAlign,
    stickySide: column.stickySide ?? 'none',
    truncate: Boolean(column.truncate),
    clamp: Boolean(!column.truncate && clampCells),
    isLastRow,
  });

  return (
    <td
      {...restProps}
      style={{
        ...getStickyStyle(column, column.cellStyle),
        ...(externalStyle || {}),
      }}
      className={styles.cell({
        class: [column.cellClassName, externalClassName],
      })}
    >
      <div
        style={column.cellContentStyle || {}}
        className={styles.content({
          class: [cellsContentClassName, column.cellContentClassName],
        })}
      >
        {column.getValue(row, rowIndex)}
      </div>
    </td>
  );
};

export default React.memo(TableCell) as typeof TableCell;
